const config = {
    apiUrl: process.env.REACT_APP_API_URL,
    stripeKey: process.env.REACT_APP_STRIPE_API_KEY,
    facebookAppId: process.env.REACT_APP_FB_APP_ID,
    googleAppId: process.env.REACT_APP_GOOGLE_APP_ID,
    gtmId: process.env.REACT_APP_GTM_ID,
    recaptchaSiteKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY,
};
export default config;